var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaste(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17808",
    d: "M0 0h20v20H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17809",
    d: "M16.333 1.667H12.85a2.49 2.49 0 0 0-4.7 0H4.667A1.672 1.672 0 0 0 3 3.333v13.334a1.672 1.672 0 0 0 1.667 1.667h11.666A1.672 1.672 0 0 0 18 16.667V3.333a1.672 1.672 0 0 0-1.667-1.666zm-5.833 0a.833.833 0 1 1-.833.833.836.836 0 0 1 .833-.833zm5.833 15H4.667V3.333h1.666v2.5h8.333v-2.5h1.667z",
    transform: "translate(-.5)",
    style: {
      fill: "#484848"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.05bb7245003b3952052ea0389ceceaf2.svg";
export { ForwardRef as ReactComponent };